import * as actionTypes from "./types";
import PolicyService from "../services/policy.service";
import util from "../utils/Util";

export const policyClaimExpenseAction = {
  errorPopup,
  closePopup,
  clearOnExit,
  getFCClaimExpenses,
  exportFCClaimExpenses
};

function beginApiCall() {
  return { type: actionTypes.POLICY_CLAIM_EXPENSE_SHOW_LOADING, payload: true };
}

function endApiCall() {
  return { type: actionTypes.POLICY_CLAIM_EXPENSE_CLOSE_LOADING, payload: false };
}

function successPopup(message) {
  return {
    type: actionTypes.POLICY_CLAIM_EXPENSE_SHOW_POPUP_SUCCESS,
    message
  };
}

function errorPopup(message) {
  return {
    type: actionTypes.POLICY_CLAIM_EXPENSE_SHOW_POPUP_ERROR,
    message
  };
}

function getFCClaimExpensesSuccess(data, filter) {
  return {
    type: actionTypes.POLICY_CLAIM_EXPENSE_SUCCESS,
    payload: data,
    filter
  };
}

function closePopup() {
  return { type: actionTypes.POLICY_CLAIM_EXPENSE_CLOSE_POPUP };
}

function clearOnExit() {
  return { type: actionTypes.POLICY_CLAIM_EXPENSE_CLEAR };
}

function getFCClaimExpenses(filter) {
  return function(dispatch, getState) {
    const policyNo = getState().policyDetails.policy.policyNo;
    dispatch(beginApiCall());
    return PolicyService.getFCClaimExpenses(policyNo, filter)
      .then(response => {
        if (response.success) {
          dispatch(endApiCall());
          dispatch(getFCClaimExpensesSuccess(response.data, response.filter));
          dispatch(successPopup(`${response.data ? response.data.length : 0} claim expense records retrieved.`));
          return response.data;
        } else {
          throw response.data;
        }
      })
      .catch(error => {
        dispatch(endApiCall());
        dispatch(errorPopup(error || "System is busy, please try again."));
      });
  };
}

function exportFCClaimExpenses(filter) {
  return function(dispatch, getState) {
    const policyNo = getState().policyDetails.policy.policyNo;
    dispatch(beginApiCall());
    return PolicyService.exportFCClaimExpenses(policyNo, filter)
      .then(response => {
        if (response.success && response.data) {
          util.downloadFile(response.data, response.filename || `Claim_Expenses_${policyNo}.xlsx`);
        }
        return response;
      })
      .then(response => {
        if (response.success) {
          dispatch(endApiCall());
          dispatch(successPopup("Claim expense report exported successfully."));
          return response.data;
        } else {
          throw response.data;
        }
      })
      .catch(error => {
        dispatch(endApiCall());
        dispatch(errorPopup("System is busy, please try again."));
      });
  };
}
